module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgNi41TDYgMTJIN1Y5SDkuNUMxMS40MzQ0IDkgMTMgMTAuNTY1NiAxMyAxMi41QzEzIDE0IDEyIDE1IDEyIDE1QzEyIDE1IDE2IDEzLjUgMTYgOS41QzE2IDYuNDYyNSAxMy41Mzc1IDQgMTAuNSA0SDdWMUg2TDAgNi41WiIgZmlsbD0iI0RGREZERiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reply-solid.svg
// module id = SkAS
// module chunks = 31